import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { callAllHandlers } from "@smartsheet/lodestar-utils";
import { useState, useMemo } from "react";
export var useFocused = function useFocused(_ref) {
  var providedOnBlur = _ref.onBlur,
    providedOnFocus = _ref.onFocus;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var onFocus = useMemo(function () {
    return callAllHandlers(providedOnFocus, function () {
      setIsFocused(true);
    });
  }, [providedOnFocus]);
  var onBlur = useMemo(function () {
    return callAllHandlers(providedOnBlur, function () {
      setIsFocused(false);
    });
  }, [providedOnBlur]);
  return {
    isFocused: isFocused,
    onBlur: onBlur,
    onFocus: onFocus
  };
};
//# sourceMappingURL=useFocused.js.map